import React, { Component } from 'react';
import { UncontrolledAlert } from 'reactstrap';
import { connect } from 'react-redux';
import { withRouter } from "react-router-dom";
import { bindActionCreators } from 'redux';
import { CircularProgress } from 'material-ui/Progress';
import { FormControl } from 'material-ui/Form';
import Select from 'material-ui/Select';
import { MenuItem } from 'material-ui/Menu';
import Input, { InputLabel } from 'material-ui/Input';
import { Card, CardBody, CardFooter, CardHeader, CardSubtitle, CardText } from 'reactstrap';
import { arrayMove, SortableContainer } from 'react-sortable-hoc';

import DataTable from './datatable';

import PageSubHeader from '../../pagesubheader'
import ContainerHeader from '../../../components/ContainerHeader/index';
import * as userdetails from '../../../actions/userdetails';
import * as loadswitchercommittees from '../../../actions/teamdetails';

class UserOrder extends Component {

    constructor(props) {
        super(props)
        // console.log('this.props.loginUser.data', this.props)
        this.state = {
            committee_id: Number(this.props.loginUser.data.committee_id ? this.props.loginUser.data.committee_id : 0),
            filterText: '',
        }
    }

    handleChange(e) {
        // this.setState({ [name]: event.target.value });
        this.setState({ committee_id: e.target.value });
    };

    handleChangeTeam(e) {
    }

    componentDidMount() {
        // console.log('componentDidMount')
        // console.log('props', this.props)
        this.props.actions.getUserOrderDetailsList();
    }

    handleUserInput(filterText) {
        this.setState({ filterText: filterText });
    };

    render() {
        const { userDetails, teamDetails, match, loginUser } = this.props;

        const committeeList = teamDetails.switchteamdetailsList;
        let dataList = <tr><td></td></tr>;
        let message = null;
        let UserdetailsList = null
        // console.log('this.state.setValue', this.state.setValue);
        if ((userDetails && userDetails.Status) || (userDetails && userDetails.actionStatus)) {
            message = <div className="loader-container"><CircularProgress color="secondary" size={50} /></div>
        }
        else if (userDetails && userDetails.UserdetailsList && userDetails.UserdetailsList.length > 0) {
            UserdetailsList = userDetails.UserdetailsList
        }
        return (
            <div className="slideInUpTiny ">
                {message}
                <ContainerHeader title="User Order" match={match} />
                <div className="row mb-md-4">
                    <div className="col-12">
                        {/* <PageSubHeader committee_id={this.state.committee_id} handleChangeTeam={this.handleChangeTeam.bind(this)}
                            teamDetails={null} hideSearch={true}
                            onUserInput={this.handleUserInput.bind(this)} /> */}

                        <div className="row">
                            <div className="col-12">
                                <div className="animated slideInUpTiny animation-duration-3">
                                    <DataTable UserdetailsList={UserdetailsList}
                                        committee_id={this.state.committee_id} loggedinUserRole_id={loginUser.data.role_id}
                                        onSortEnd={this.onSortEnd} useDragHandle={true} />
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <div>
                    <p>Note : In Ipad meeting attendees will be ordered in below sequence. To Update the sequence click and drag the icon in reorder column.</p>
                </div>
            </div >
        );
    }
}

function mapStateToProps(state, ownProps) {
    // console.log('state=>', state)
    const { userDetails, teamDetails, loginUser } = state
    const { match } = ownProps
    return { userDetails, teamDetails, match, loginUser }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, userdetails, loadswitchercommittees), dispatch)
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(UserOrder);





// WEBPACK FOOTER //
// ./app/userdetails/userorder/index.js